import { errMsg as rawErrMsg } from "@/lib/api";

/** Map of exact backend error strings → i18n replacement (per language).
 *  When we recognise a backend message, we substitute the localised copy.
 *  Unknown messages pass through unchanged. */
const OVERRIDES = {
  nl: {
    "that email and password don't match. double-check both.":
      "Dit e-mailadres en wachtwoord komen niet overeen. Controleer beide velden.",
    "Inner Compass is currently invite-only. Ask your organization or pilot lead for access.":
      "Inner Compass is momenteel alleen op uitnodiging. Vraag je organisatie of pilot-lead om toegang.",
    "Missing bearer token":
      "Je sessie is beëindigd. Log opnieuw in.",
  },
  en: {}, // pass-through
};

/** Language-aware wrapper around errMsg — swaps known backend messages for
 *  translated ones. Unknown messages pass through. */
export function localizeErr(e, lang, fallback) {
  const raw = rawErrMsg(e, fallback);
  if (!raw) return raw;
  const table = OVERRIDES[lang] || {};
  const trimmed = String(raw).trim();
  return table[trimmed] || raw;
}
